import React from 'react';
import {Field} from 'redux-form';

import './_product-form-chunking-info.scss';
import {CHUNKING_SIZES} from '../../../../constants/Products';
import {translate} from '../../../../services';
import {renderSelect} from '../../../../utils/form';
import {getChunkSizeOfRemainingPieces, getPiecesAtChosenChunkSize} from '../../../../utils/orders';
import ChunkingInfo from '../../ChunkingInfo/ChunkingInfo';


interface ProductFormChunkingInfoProps {
  chunkSize?: number;
  quantity?: number;
  chunkingUnit?: string;
  setChunkSize?: (chunkSize?: number | unknown) => void;
}

const ProductFormChunkingInfo = ({chunkSize, chunkingUnit, quantity, setChunkSize}: ProductFormChunkingInfoProps): JSX.Element => {
  const placeholderChunkSize = chunkSize ? chunkSize : 8;
  const piecesAtChosenChunkSize = getPiecesAtChosenChunkSize(quantity, placeholderChunkSize);
  const chunkSizeOfRemainingPieces = getChunkSizeOfRemainingPieces(quantity, piecesAtChosenChunkSize, placeholderChunkSize);
  const remainingChunkSizeIsPositive = chunkSizeOfRemainingPieces > 0;

  const renderChunkingOptions = () => {
    const options = CHUNKING_SIZES.map((chunkingSize) => ({
      label: `${chunkingSize} ${chunkingUnit}`,
      value: chunkingSize
    }));

    return (
      <Field
        name='chunking-size'
        component={renderSelect}
        formPrefix='chunking-size'
        placeholder={`${placeholderChunkSize} ${chunkingUnit}`}
        isClearable={false}
        options={options}
        className='chunking-size-form'
        classNamePrefix='react-select'
        onChange={setChunkSize}
      />
    );
  };

  return (
    <section className='b-product-form-chunking-info detail-section'>
      <h3 className='h2'>{translate('fabric.headlines.chunking')}</h3>
      <div className='chunking-box'>
        {renderChunkingOptions()}
        <ChunkingInfo
          piecesAtChosenChunkSize={piecesAtChosenChunkSize}
          chunkSize={placeholderChunkSize}
          unit={chunkingUnit}
          remainingChunkSizeIsPositive={remainingChunkSizeIsPositive}
          chunkSizeOfRemainingPieces={chunkSizeOfRemainingPieces}/>
      </div>
    </section>
  );
};

export default ProductFormChunkingInfo;
